import React, { memo } from 'react'
import NonFlexingContainer from '@sport1/news-styleguide/NonFlexingContainer'
import Font from '@sport1/news-styleguide/Font'
import { TeaserProps } from '@sport1/types/web'
import Teaser from '@/components/Teaser'
import { TeaserSizeTypes } from '@/types/teaser'
import { sport1CondensedBlackItalic } from '@/helpers/fonts'

type Props = {
    content: TeaserProps[]
    headline?: string
    showAsList?: boolean
}

const LivetickerTeaser = ({ content, headline, showAsList }: Props) =>
    content?.length ? (
        <NonFlexingContainer
            marginBottom="spacing-9"
            paddingX={['spacing-7', 'spacing-7', 'spacing-9', 'spacing-none']}
            testID="liveticker-teaser-container"
        >
            {headline && (
                <Font
                    fontVariant="Display-S"
                    nextFontFamilyVariant={sport1CondensedBlackItalic.style.fontFamily}
                    fontFamilyVariant="Sport1-CondensedBlackItalic"
                    paddingBottom="spacing-7"
                >
                    {headline}
                </Font>
            )}
            <Teaser
                size={showAsList ? TeaserSizeTypes.LIST : TeaserSizeTypes.BIG}
                teaser={content[0]}
            />
        </NonFlexingContainer>
    ) : null

export default memo(LivetickerTeaser)
